export default __webpack_public_path__ + "static/media/Amvegan.55585ab9.pdf";